import type { CarrierDto } from "@babackapp/private-api-client/types";

export function CarrierName({ carrier }: { carrier: CarrierDto }) {
  return <span>{carrier.title || carrier.code}</span>;
}
